import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  crearAutorizacion: ["payload"],
  crearAutorizacionLoading: null,
  crearAutorizacionSuccess: ["crearAutorizacionData"],
  crearAutorizacionFailure: ["crearAutorizacionError"],

  cancelarAutorizacion: ["payload"],
  cancelarAutorizacionLoading: null,
  cancelarAutorizacionSuccess: ["cancelarAutorizacionData"],
  cancelarAutorizacionFailure: ["cancelarAutorizacionError"],

  getAutorizacion: ["payload"],
  getAutorizacionLoading: null,
  getAutorizacionSuccess: ["getAutorizacionData"],
  getAutorizacionFailure: ["getAutorizacionError"],

  consultarAutorizaciones: ["payload"],
  consultarAutorizacionesLoading: null,
  consultarAutorizacionesSuccess: ["consultarAutorizacionesData"],
  consultarAutorizacionesFailure: ["consultarAutorizacionesError"],

  reactivarAutorizacion: ["payload"],
  reactivarAutorizacionLoading: null,
  reactivarAutorizacionSuccess: ["reactivarAutorizacionData"],
  reactivarAutorizacionFailure: ["reactivarAutorizacionError"],

  limpiarDatosAutorizacion: ["payload"],
  limpiarDatosAutorizacionLoading: null,

  consultarAutorizacionHija: ["payload"],
  consultarAutorizacionHijaLoading: null,
  consultarAutorizacionHijaSuccess: ["consultarAutorizacionHijaData"],

  formAutorizacionDiagnostico: ["payload"],
  formAutorizacionDiagnosticoLoading: null,
  formAutorizacionDiagnosticoSuccess: ["formAutorizacionDiagnosticoData"],

  getAutorizacionesDiagnostico: ["payload"],
  getAutorizacionesDiagnosticoLoading: null,

  modificarDiagnosticoDefinitivo: ["payload"],
  modificarDiagnosticoDefinitivoLoading: null,

  confirmarDiagnosticoDefinitivo: ["payload"],
  confirmarDiagnosticoDefinitivoLoading: null,
});

export { Types };

export default Creators;
